import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { stateAbbreviation } from '../../helpers/Address';
import { renderDate } from '../../helpers/Date';
import { ModalButtonGroup, ModalCancelButton, ModalSaveButton } from '../Modals';

const SupporterDetails = ({ fullname, streetAddress, postalAddress, mobile, mobileModified, phone, phoneModified, email, onClose, handleEditClick }) => (
  <Fragment>
    <div className="contact-details-modal__content">
      <div>
        <h3 className="contact-details-modal__name">{fullname}</h3>
        <hr />
        <div className="contact-details-modal__row">
          <div className="contact-details-modal__label label-with-meta">
            <div>Street Address</div> {streetAddress.modified && <small className="meta">Updated: {renderDate(streetAddress.modified)}</small>}
          </div>
          <div className="contact-details-modal__value">
            {[
              streetAddress.address_line_1,
              streetAddress.address_line_2,
              streetAddress.suburb,
              streetAddress.city,
              streetAddress.zip,
              stateAbbreviation(streetAddress.state),
              streetAddress.country,
            ]
              .filter((el) => el !== undefined && el !== '')
              .join(', ')}{' '}
          </div>
        </div>
        <div className="contact-details-modal__row">
          <div className="contact-details-modal__label label-with-meta">
            <div>Postal Address</div>
            {postalAddress.modified && <small className="meta">Updated: {renderDate(postalAddress.modified)}</small>}
          </div>
          <div className="contact-details-modal__value">
            {[
              postalAddress.address_line_1,
              postalAddress.address_line_2,
              postalAddress.suburb,
              postalAddress.city,
              postalAddress.zip,
              stateAbbreviation(postalAddress.state),
              postalAddress.country,
            ]
              .filter((el) => el !== undefined && el !== '')
              .join(', ')}{' '}
          </div>
        </div>
        <div className="contact-details-modal__row">
          <div className="contact-details-modal__label label-with-meta">
            <div>Mobile</div>
            {mobileModified && <small className="meta">Updated: {renderDate(mobileModified)}</small>}
          </div>
          <div className="contact-details-modal__value">{mobile}</div>
        </div>
        <div className="contact-details-modal__row">
          <div className="contact-details-modal__label label-with-meta">
            <div>Phone</div>
            {phoneModified && <small className="meta">Updated: {renderDate(phoneModified)}</small>}
          </div>
          <div className="contact-details-modal__value">{phone}</div>
        </div>
        <div className="contact-details-modal__row">
          <div className="contact-details-modal__label">Email</div>
          <div className="contact-details-modal__value">{email && <a href={`mailto:${email}`}>{email}</a>}</div>
        </div>
      </div>
    </div>
    <ModalButtonGroup>
      <ModalCancelButton onClick={onClose}>Close</ModalCancelButton>
      {handleEditClick && typeof handleEditClick === 'function' && (
        <ModalSaveButton onClick={handleEditClick}>
          <span>
            Edit
            <span className="hide-on-mobile">&ensp;Contact Details</span>
          </span>
        </ModalSaveButton>
      )}
    </ModalButtonGroup>
  </Fragment>
);

SupporterDetails.defaultProps = {
  email: '',
  fullname: '',
  mobile: '',
  mobileModified: null,
  phone: '',
  phoneModified: null,
  postalAddress: {},
  streetAddress: {},
};

SupporterDetails.propTypes = {
  email: PropTypes.string,
  fullname: PropTypes.string,
  handleEditClick: PropTypes.func.isRequired,
  mobile: PropTypes.string,
  mobileModified: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  phone: PropTypes.string,
  phoneModified: PropTypes.number,
  postalAddress: PropTypes.objectOf(PropTypes.any),
  streetAddress: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  email: state.supporters.contactModal.contactDetails.email,
  fullname: state.supporters.contactModal.contactDetails.fullname,
  isOpen: state.supporters.contactModal.isOpen,
  mobile: state.supporters.contactModal.contactDetails.mobile,
  mobileModified: state.supporters.contactModal.contactDetails.mobile_modified,
  phone: state.supporters.contactModal.contactDetails.phone,
  phoneModified: state.supporters.contactModal.contactDetails.phone_modified,
  postalAddress: state.supporters.contactModal.contactDetails.postalAddress,
  streetAddress: state.supporters.contactModal.contactDetails.streetAddress,
});

export default connect(mapStateToProps)(SupporterDetails);
